/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  AbiDecoder,
  AbiDecoderInterface,
} from "../../contracts/AbiDecoder";

const _abi = [
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
] as const;

const _bytecode =
  "0x60556032600b8282823980515f1a607314602657634e487b7160e01b5f525f60045260245ffd5b305f52607381538281f3fe730000000000000000000000000000000000000000301460806040525f80fdfea2646970667358221220fceccc785d4abf44022ea4769c3dad431f2efd4d9664987d221de4b4da7ec51164736f6c63430008150033";

type AbiDecoderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AbiDecoderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AbiDecoder__factory extends ContractFactory {
  constructor(...args: AbiDecoderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      AbiDecoder & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): AbiDecoder__factory {
    return super.connect(runner) as AbiDecoder__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AbiDecoderInterface {
    return new Interface(_abi) as AbiDecoderInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): AbiDecoder {
    return new Contract(address, _abi, runner) as unknown as AbiDecoder;
  }
}
